import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useState } from "react";
import { Toaster } from "sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { CartProvider } from "./contexts/CartContext";
import { LocationProvider } from "./contexts/LocationContext";
import { LoadingProvider } from "./contexts/LoadingContext";
import SplashScreen from "./components/SplashScreen";
import HomePage from "./pages/HomePage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import AdminDashboard from "./pages/AdminDashboard";
import MerchantDetailPage from "./pages/MerchantDetailPage";
import CategoryProductsPage from "./pages/CategoryProductsPage";
import SellerOnboardingPage from "./pages/SellerOnboardingPage";

// Routes that skip the SplashScreen (they don't depend on merchant/category loading)
const SKIP_SPLASH_ROUTES = ["/admin", "/seller-onboarding"];

function AppContent({ isLoading, onLoadingComplete }) {
  const location = useLocation();
  const shouldSkipSplash = SKIP_SPLASH_ROUTES.some(r => location.pathname.startsWith(r));

  return (
    <>
      {isLoading && !shouldSkipSplash && (
        <SplashScreen onLoadingComplete={onLoadingComplete} />
      )}
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/merchant/:alias" element={<MerchantDetailPage />} />
          <Route path="/category/:categoryName" element={<CategoryProductsPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/seller-onboarding" element={<SellerOnboardingPage />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </div>
    </>
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <LoadingProvider>
      <LanguageProvider>
        <LocationProvider>
          <CartProvider>
            <BrowserRouter>
              <AppContent isLoading={isLoading} onLoadingComplete={handleLoadingComplete} />
            </BrowserRouter>
          </CartProvider>
        </LocationProvider>
      </LanguageProvider>
    </LoadingProvider>
  );
}

export default App;
